import { options } from '@engine/features/apply_chosen';
var moneyTransferTypeSelector = '#transfer_to_payout_transaction_money_transfer_type';
var payerIdSelector = '#transfer_to_payout_transaction_payer_id';
var payersContainer = '#payers_container';
var creditPartyIdentifiersContainer = '#credit_party_identifiers_container';

function requirementsRequest(payerId, container) {
  $.ajax({
    type: 'GET',
    url: '/transfer_to_payers/transaction_requirements',
    data: {
      payer_id: payerId
    }
  }).done(function (requirements) {
    container.html($.parseHTML(requirements));
    $('.for_chosen', container).chosen(options);
    $('.transfer_to_date_input', container).datetimepicker();
  });
}

function payersRequest(moneyTransferType, container) {
  $.ajax({
    type: 'GET',
    url: '/transfer_to_payers/payers',
    data: {
      money_transfer_type: moneyTransferType
    }
  }).done(function (requirements) {
    container.html(requirements);
    $('.for_chosen', container).chosen(options);
    $(creditPartyIdentifiersContainer).html('');
  });
}

function listenForMoneyTransferTypeChange() {
  $(document).on('change', moneyTransferTypeSelector, function () {
    payersRequest($(moneyTransferTypeSelector).val(), $(payersContainer));
  });
}

function listenForPayerChange() {
  $(document).on('change', payerIdSelector, function () {
    requirementsRequest($(payerIdSelector).val(), $(creditPartyIdentifiersContainer));
  });
}

var TransferTo = {
  listenForPayerChange: listenForPayerChange,
  listenForMoneyTransferTypeChange: listenForMoneyTransferTypeChange
};
export default TransferTo;